/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import styled from 'styled-components';

export const StyledHeader = styled.div`
  background: #104972 url(./images/bg.png) left bottom repeat;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
  padding: 0 50px;
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  height: 56px;
  ul {
    list-style: none;
    margin-top: auto;
  }
  .header-logo {
    display: inline-block;
    margin-right: 30px;
    img {
      height: 32px;
    }
  }
  .header-icon {
    margin-right: 30px;
    width: 65px;
    display: block;
    white-space: nowrap;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
  }

  .dyc-svg-icon[code='icon-news'] {
    color: #fff;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  @media screen and (max-width: 1280px) {
    .header-container {
      padding: 0 30px;
    }
  }
`;
